import * as LucideIcons from "lucide-react";

// Renders a lucide icon by its string name (used for data-driven icons).
export const Icon = ({ name, className = "", size = 24, strokeWidth = 1.5 }) => {
  const Cmp = LucideIcons[name] || LucideIcons.Sparkles;
  return <Cmp className={className} size={size} strokeWidth={strokeWidth} aria-hidden="true" />;
};

export default Icon;
